import { useState } from "react";
import Dashboard from "../../Layout/Dashboard";
import MedicalCaseTable from "../../components/cases-table/MedicalCaseTable";
import { useMedicalCases } from "../../hooks/queries";
import SimpleCalendarTableHeader from "../../components/cases-table/SimpleCalendarTableHeader";

export default function AssignedCasesListing() {
  const lazyFiltersResult = useState({
    status: null,
    assigned: true,
  });
  const lazyStateResult = useState({
    first: 1,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filters: {},
  });
  const pageSizeResult = useState(20);

  const casesQuery = useMedicalCases({
    page: lazyStateResult[0].page,
    pageSize: pageSizeResult[0],
    filters: lazyFiltersResult[0],
  });

  return (
    <Dashboard headerTitle="Casos Reasignados">
      <div className="card">
        <MedicalCaseTable
          cases={casesQuery.data?.results || []}
          isLoading={casesQuery.isLoading}
          totalCases={casesQuery.data?.total || 0}
          lazyFiltersResult={lazyFiltersResult}
          lazyStateResult={lazyStateResult}
          pageSizeResult={pageSizeResult}
          tableHeader={
            <SimpleCalendarTableHeader setLazyFilters={lazyFiltersResult[1]} />
          }
        />
      </div>
    </Dashboard>
  );
}
